import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './styles/addclass.css'

//Components
import Loader from '../components/loader'

//Extras
import { fontType, main } from '../assets/extras'
import { collection, doc, getDocs } from 'firebase/firestore'
import { db } from '../assets/connections'

const SelectSede = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const academia = location.state ? location.state.academia : null

    const [loading, setLoading] = useState(true)
    const [sedes, setSedes] = useState([])

    const getData = async () => {
        try {
            const sedesSnap = await getDocs(collection(doc(db, ref), "Sedes"))
            const sedesAux = sedesSnap.docs.map(v => ({
                id: v.id,
                ...v.data()
            }))
            setSedes(sedesAux)
        } catch(e) {
            console.log("Error cargando sedes:", e.message)
        }
        setLoading(false)
    }

    const handleSelect = (sede) => {
        navigate("/classes/add", {
            state: {
                ref,
                academia,
                sedeId: sede.id,
                sedeNombre: sede.nombre_sede
            }
        })
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            getData()
        }
    }, [])

    if(loading){
        return <Loader loading={loading} />
    }

    return (
        <div className='mainAddClass'>
            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.title,
                paddingBottom: 0
            }}>SELECCIONAR SEDE</h2>
            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.text,
                marginTop: -50,
                marginBottom: 40,
                fontSize: 18,
                padding: 10,
                paddingBottom: 20,
                paddingTop: 0
            }}>{
                localStorage.getItem("authToken") ?
                    JSON.parse(localStorage.getItem("authToken")).nombre_academia
                : ""
            }</h2>

            <div style={{
                width: "95%",
                maxWidth: 800,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 15,
                marginTop: 20
            }}>
                {sedes.length === 0 ? (
                    <p style={{
                        fontFamily: fontType.text,
                        fontSize: 18,
                        color: "#666"
                    }}>No hay sedes configuradas. Configura sedes primero.</p>
                ) : (
                    sedes.map(s => (
                        <button key={s.id} onClick={() => handleSelect(s)} style={{
                            width: "100%",
                            padding: 20,
                            backgroundColor: "white",
                            border: `2px solid ${main}`,
                            borderRadius: 10,
                            cursor: "pointer",
                            fontFamily: fontType.text,
                            fontSize: 18,
                            fontWeight: "bold",
                            color: "#333",
                            transition: "all 0.2s"
                        }}
                            onMouseEnter={e => {
                                e.target.style.backgroundColor = main
                                e.target.style.color = "white"
                            }}
                            onMouseLeave={e => {
                                e.target.style.backgroundColor = "white"
                                e.target.style.color = "#333"
                            }}
                        >
                            {s.nombre_sede}
                            {s.direccion_sede && (
                                <span style={{
                                    display: "block",
                                    fontSize: 14,
                                    fontWeight: "normal",
                                    marginTop: 5,
                                    pointerEvents: "none"
                                }}>{s.direccion_sede}</span>
                            )}
                        </button>
                    ))
                )}
            </div>
        </div>
    )
}

export default SelectSede
